export default __webpack_public_path__ + "static/media/Initiate's Sandals of the Crescent.e26d5021.jpg";